import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import { HiMiniArrowUpRight } from "react-icons/hi2";
import Particles from '../Components/animate/BgAnimate/Particles';
import GradientBlinds from '../Components/animate/BgAnimate/GradientBlinds';
import { Link } from 'react-router-dom';
import { GoArrowRight } from "react-icons/go";

const HeroSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div
      className="relative flex flex-col overflow-hidden min-h-screen "
      // style={{
      //   background:
      //     'linear-gradient(164deg, rgba(18, 18, 18, 1) 33%, rgba(0, 52, 111, 1) 57%, rgba(29, 233, 147, 1) 100%)',
      // }}
    >
      {/* Particles Background */}
      <div className="absolute inset-0 z-0 bg-bgDefault">
        <GradientBlinds
          gradientColors={['#2CC980', '#5227FF']}
          angle={0}
          noise={0.3}
          blindCount={12}
          blindMinWidth={50}
          spotlightRadius={0.5}
          spotlightSoftness={1}
          spotlightOpacity={1}
          mouseDampening={0.15}
          distortAmount={0}
          shineDirection="left"
          mixBlendMode="lighten"
        />
      </div>

      {/* Content */}
      <section className="relative z-10 text-white px-5 pt-48  lg:px-16 lg:py-48  ">
        <div className="container xl:mx-auto xl:max-w-screen-xl overflow-hidden">
          <div className="grid grid-cols-1 text-center" data-aos="fade-up">
            <h1 className="text-heading-4 leading-[38px] md:text-heading-1 font-dmsans font-bold mb-6 md:tracking-[-0.06em] mb:leading-[96px]">
              Explore the world<br />
              of{' '}
              <span className="text-[#00E599] font-crimsonpro font-normal italic text-heading-4 leading-[32px] md:text-[86px]">
                AI{' '}
              </span>
              and Digital{' '}
              <span className="text-[#00E599] font-crimsonpro font-normal italic text-heading-4  leading-[32px] md:text-[86px]">
                Innovation
              </span>
              {/* <span className="blink-underscore text-green-400 font-thin ml-1">_</span> */}
            </h1>
          </div>

          <div className=" mt-7 lg:mt-0 text-center md:px-48 " >
            <div className="text-[#FFFFFF]  md:text-body md:font-normal font-roboto text-body-sm lg:px-28">
              <p>
                Helping Startups Shape the Future with Scalable Software
                and Enterprise AI solutions built through Informed Strategy,
                Design, and Execution.<br />
              </p>
              {/* <a
              href="#"
              className="inline-flex items-center justify-center gap-x-2 text-[#121212] font-dmsans font-extrabold text-[24px] md:text-[20px] lg:font-bold leading-[100%] 
                        bg-[#00E599] rounded-full px-6 py-3 mt-6 shadow-md hover:shadow-lg transition-all duration-300"
            >
              Let’s Talk
              <HiMiniArrowUpRight className="text-[24px] md:text-[30px]" />
            </a> */}

             <Link
              to="/contact"
              className="group inline-flex items-center justify-center gap-x-2 text-[#121212] font-roboto font-extrabold text-[12px] md:text-[20px] lg:font-bold leading-[100%] 
                        bg-[#00E599] rounded-full px-6 py-3 lg:py-4 lg:px-10 mt-6 shadow-md hover:shadow-lg transition-all duration-300"
            >
              Let’s Talk
              <GoArrowRight 
                className="text-[24px] md:text-[30px] transition-transform duration-300 group-hover:translate-x-2" 
              />
            </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HeroSection;
